import React, { useEffect } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

export async function getServerSideProps({ locale, locales }) {
  return {
    redirect: {
      destination: `/feedback/feature-requests/`,
      statusCode: 301,
    },
  }
}
export default function index({ content, locale, locales }) {
  return null
}
export const FeedbackTop = () => {
  const router = useRouter()
  return (
    <div className="feedbacktop">
      <div className="title">
        <span>Feedback</span>
      </div>
      <div className="boards">
        <Link
          href={'/feedback/feature-requests/'}
          style={{ color: router.pathname.includes('feature-requests') ? '#09323a' : 'none' }}
        >
          Features Requests
        </Link>
        <Link
          href={'/feedback/bugs/'}
          style={{ color: router.pathname.includes('bugs') ? '#09323a' : 'none' }}
        >
          Bugs
        </Link>
      </div>
    </div>
  )
}
